export default "__VITE_ASSET__oXZbaeI3__"